import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Keypoint {
    constructor(root) {
        this.root = root;
        this.number = this.root.querySelector('[data-keypoint--number]');
        this.title = this.root.querySelector('[data-keypoint--title]');
        this.text = this.root.querySelector('[data-keypoint--text]');
        
        this.init();
    }

    init() {
        this.anim = gsap.timeline({
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                // markers: true,
            },
        })

        this.anim.fromTo(this.title, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.7,
            ease: 'out',
        }, '#start');

        this.anim.fromTo(this.number, {
            opacity: 0,
            xPercent: -20,
        }, {
            opacity: 1,
            xPercent: 0,
            duration: 0.3,
            ease: 'out',
        }, '#start+=0.2');

        if (this.text) {
            this.anim.fromTo(this.text, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start+=0.2');
        }
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-keypoint]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-keypoint]').forEach(root => {
            const instance = new Keypoint(root)
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
